module.exports = __webpack_public_path__ + "img/man.e4cf73db.png";